import * as React from 'react'
import { BREAKPOINT_DESKTOP, COLORS, MOBILE_HEADER_HEIGHT } from 'static/constants'
import styled from 'styled-components'
import { SidebarContent } from './SidebarContent'

interface IDashOBarNavItemProps {
  open?: boolean
  roleLabel: string
  approvedUser: boolean
}

const CommonSidebar: React.VFC<IDashOBarNavItemProps> = ({ open, roleLabel, approvedUser }) => {
  return (
    <Sidebar open={open}>
      <div className="Scroller">
        <SidebarContent roleLabel={roleLabel} approvedUser={approvedUser} />
      </div>
    </Sidebar>
  )
}

const Sidebar = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 260px;
  min-height: 100%;
  align-self: flex-start;
  flex-shrink: 0;
  text-align: center;
  display: block;
  flex-direction: column;
  padding: 22px 0 40px;

  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    overflow: ${props => (props.open ? 'auto' : 'hidden')};
    width: ${props => (props.open ? 'auto' : 0)};
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: ${COLORS.background};
    z-index: 1000;
    padding: ${MOBILE_HEADER_HEIGHT}px 0;
    ${props =>
      props.active &&
      `
      border-left: 4px solid ${COLORS.primary};
    `};
  }
  .Scroller {
    @media (max-width: ${BREAKPOINT_DESKTOP}px) {
      height: 100%;
      overflow: hidden auto;
    }
  }
  .CalenderWrapper {
    height: 300px;
  }
`

export default CommonSidebar
